import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  anagraficaList: [],
  selectedAnagrafica: {},
};

const anagraficaSlice = createSlice({
  name: "anagrafica",
  initialState,
  reducers: {
    populateAnagraficaList: (state, action) => {
      state.anagraficaList = action.payload.anagraficaList;
    },
    selectAnagrafica: (state, action) => {
      state.selectedAnagrafica = action.payload.selectedAnagrafica;
    },
    updateDiagnosiReferto: (state, action) => {
      const { diagnosiReferto } = action.payload;
      if (state.selectedAnagrafica) {

        state.selectedAnagrafica.diagnosiReferto = diagnosiReferto;
      }
    },
  },
});

export const { populateAnagraficaList, selectAnagrafica, updateDiagnosiReferto } =
  anagraficaSlice.actions;
export default anagraficaSlice.reducer;
